"use strict";
// This allows us to load Angular components on legacy server-side pages.
import { Injector, NgModuleFactoryLoader, SkipSelf, } from '@angular/core';
import '../app/rxjs-operators';
import { components } from './components';
var CompatComponent = (function () {
    function CompatComponent(injector, loader) {
        this.injector = injector;
        this.loader = loader;
    }
    CompatComponent.prototype.ngOnInit = function () {
        var _this = this;
        components
            .filter(function (_a) {
            var selector = _a.selector;
            return document.getElementsByTagName(selector)[0];
        })
            .forEach(function (_a) {
            var selector = _a.selector, loadChildren = _a.loadChildren, component = _a.component, path = _a.path;
            return _this.loader
                .load(loadChildren)
                .then(function (ngModuleFactory) {
                // NgModuleFactory
                var componentFactory = ngModuleFactory
                    .create(_this.injector) // ngModuleRef
                    .componentFactoryResolver.resolveComponentFactory(component);
                if (path === 'hack_path_not_used_index_0') {
                    _this.entryPoint.createComponent(componentFactory, 0);
                }
                else {
                    _this.entryPoint.createComponent(componentFactory);
                }
            });
        });
    };
    CompatComponent.ctorParameters = function () { return [{ type: Injector, decorators: [{ type: SkipSelf }] }, { type: NgModuleFactoryLoader }]; };
    return CompatComponent;
}());
export { CompatComponent };
//# sourceMappingURL=compat.component.js.map


// WEBPACK FOOTER //
// compat.component.js